<template>
  <div class="question-input-radio">
    <b-field
      v-for="choice in choices"
      :key="getChoice(choice)"
    >
      <b-radio
        v-model="answer"
        :native-value="getChoice(choice)"
        @input="$emit('answered', answer)"
      >
        <QuestionChoice :choice="choice" />
      </b-radio>
    </b-field>
  </div>
</template>


<script>
import QuestionChoice from './QuestionChoice.vue';

export default {
  name: 'ComponentName',
  components: { QuestionChoice },
  props: ['choices', 'prevAnswer'],
  data() {
    return {
      answer: this.prevAnswer || '',
    };
  },
  computed: { /*
      Creates a new property
      Updates when any dependant property changes */
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    getChoice(choice) {
      if (typeof choice === 'string') return choice;
      return choice.text;
    },
  },
};
</script>


<style scoped>

</style>
